import { jsx } from "react/jsx-runtime";
import "react";
import GoogleForm from "./GoogleForm.esm.js";
const GoogleFormBlock = {
  Component: ({
    attrs
  }) => {
    return /* @__PURE__ */ jsx(GoogleForm, { ...attrs });
  },
  metadata: {
    version: "1.0",
    name: "constellation/google-form",
    title: "Google Form",
    description: "Embed a Google Form with user ID prefill from cookies",
    icon: "feedback",
    keywords: ["form", "google", "embed", "user"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "Forms",
    attributes: {
      formId: {
        type: "string",
        default: "",
        label: "Google Form ID",
        control: "text",
        help: "The form ID from the Google Form URL (e.g., the part after /d/e/ in the URL)"
      },
      zuidFieldName: {
        type: "string",
        default: "",
        label: "Zuid Field Name",
        control: "text",
        help: "The prefill field name for Zuid (e.g., entry.225838711)"
      },
      width: {
        type: "number",
        label: "Width",
        default: 640,
        control: "number"
      },
      height: {
        type: "number",
        label: "Height",
        default: 586,
        control: "number"
      }
    }
  }
};
export {
  GoogleFormBlock as default
};
